/* Maison Tanger — Motion System v4 (CRO-safe)
   Fly To Cart uniquement (motif BYQ Supply).

   Le sticky add-to-cart mobile qui vivait ici (v3, Module 1) a ete retire le
   2026-08-26 : le nouveau `sections/mt-sticky-atc.liquid` (M59, motif BYQ
   « kelvin-ecommerce-4 ») fait exactement ce travail en mieux — rendu server-side,
   configurable dans l'editeur de theme, gere correctement le prix barre en promo.
   Garder les deux aurait affiche DEUX barres flottantes empilees en bas de l'ecran
   des qu'un visiteur scrollait sous le bouton d'achat : bug visible, corrige avant
   publication plutot qu'apres.

   Retire lors de l'audit CRO M57 (toujours vrai) : reveals au scroll, titres
   masques mot a mot, parallax — ils laissaient des cartes et des CTA vides
   plusieurs secondes sur une boutique a 0,19 % d'ajout au panier.

   Regle dure : rien ici ne met de contenu a opacity:0. Jamais. */

/* ---------- Fly To Cart ----------
   A l'ajout au panier, l'image du produit vole vers l'icone du panier, qui reagit.
   Pourquoi : le panier est une PAGE ici (cart_type: page). Sans retour visuel,
   l'acheteur ne sait pas que son clic a fonctionne — il re-clique ou abandonne.
   N'intercepte jamais la soumission du formulaire : le panier reste la source de verite. */
(function () {
  'use strict';

  if (window.__mtFlyCart) return;
  window.__mtFlyCart = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cartTarget() {
    return document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]');
  }

  function sourceImage(fromEl) {
    /* Si le clic vient de la barre panier collante (M59), on prefere sa propre
       vignette : l'image principale du produit peut etre scrollee hors-ecran
       a ce moment-la, ce qui ferait voler l'animation depuis un point invisible. */
    var satc = fromEl.closest('[data-mt-satc]');
    if (satc) {
      var satcImg = satc.querySelector('.mt-satc__img');
      if (satcImg) return satcImg;
    }
    var scope = fromEl.closest('.card-wrapper, .product, .featured-product, form') || document;
    return scope.querySelector('.card__media img, .product__media img, .media img, img');
  }

  function fly(fromEl) {
    if (reduce.matches) return;
    var target = cartTarget();
    var img = sourceImage(fromEl);
    if (!target || !img || !img.src) return;

    var s = img.getBoundingClientRect();
    var t = target.getBoundingClientRect();
    if (!s.width || !t.width) return;

    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.className = 'mt-fly';
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.left = s.left + s.width / 2 - 32 + 'px';
    ghost.style.top = s.top + s.height / 2 - 32 + 'px';
    document.body.appendChild(ghost);

    var dx = t.left + t.width / 2 - (s.left + s.width / 2);
    var dy = t.top + t.height / 2 - (s.top + s.height / 2);

    var anim = ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 40) + 'px) scale(0.7)', opacity: 0.95, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.18)', opacity: 0.2 }
      ],
      { duration: 720, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    );

    function done() {
      ghost.remove();
      var bubble = document.querySelector('#cart-icon-bubble, .header__icon--cart');
      if (bubble) {
        bubble.classList.remove('mt-cart-pop');
        void bubble.offsetWidth;
        bubble.classList.add('mt-cart-pop');
        setTimeout(function () { bubble.classList.remove('mt-cart-pop'); }, 420);
      }
    }

    if (anim && anim.finished && anim.finished.then) {
      anim.finished.then(done).catch(done);
    } else {
      setTimeout(done, 760);
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[name="add"], .quick-add__submit, [data-mt-satc-add]');
      if (!e.isTrusted || !btn || btn.disabled || btn.hasAttribute('data-mt-choose')) return;
      try { fly(btn); } catch (err) { /* ne jamais bloquer l'ajout au panier */ }
    },
    true
  );
})();
